export enum LicenseRoleActionTypes {
    API_RESPONSE_SUCCESS = '@@categories/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@categories/API_RESPONSE_ERROR',

    GET_LICENSE_ROLES = '@@categories/GET_LICENSE_ROLES',
}
